/**
 * @file   Source/gitcha_Web/src/constants/pageURLs.js
 * @brief  This file is responsible for urls used in navigation across app
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
const mobileBasePath = "/mobile/";
export const pageURLs = Object.freeze({
  login: "/login",
  signup: "/signup",
  wantad: "/home",
  dashboard: "/home",
  home: "/home",
  match: "/match",
  createwantad: "/create-want-listing",
  wantAdDetails: "/want-listing-details",
  wantAdStrengthen: "/strengthen-want-listing",
  notFound: "404-not-found",
  deletedWantAd: "want-listing/deleted-want-listing",
  agentCreatewantadMainScreen: "/want-listing-creation",
  agentCreatewantad: "/create-want-listing-agent",
  agentEditwantad: "/edit-want-listing",
  editWantAdForAgents: "/edit-want-listing-agent",
  inventoryDetails: "/inventory-details",
  memberCreateInventory: "/create-inventory",
  inventoryStrengthen: "/strengthen-inventory",
  selectYourPlan: "/select-your-plan",
  completeYourProfilePremium: "/complete-your-profile-premium",
  completeYourProfileDefault: "/complete-your-profile",
  agentCreateInventory: "/create-inventory",
  agentDraftList: "/agent-draft-inventory",
  consumerInventoryListing: "/my-inventory-listing",
  agentWantAdConfirmation: "/agent-want-ad-confirmation",
  agentInventoryListing: "/my-inventory",
  agentMyClients: "/my-clients",
  agentMyWantAdListings: "/my-want-listings",
  memberEditInventory: "/member-edit-Inventory",
  settings: "/settings",
  addNewCard: "/add-new-card",
  viewClientDetails: "/view-client",
  agentDashboard: "/agent-dashboard",
  allIntroductions: "/all-introductions",
  viewIntroducedInventory: "/view-introduced-property",
  accessCodePage: "/",
  gitchaMemberWelcome: "/want-listing-onboard",
  gitchaPrivacyPolicy: "/privacy-policy",
  gitchaTermsOfService: "/terms-of-service",
  gitchaInvetoryOnBoard: "/inventory-onboard",
  wantAdPubicDetailsPage: "/want-listing",
  wantAdPubicMobileDetailsPage: `${mobileBasePath}want-listing`,
  mobileSignIn: `${mobileBasePath}signin`,
  updatePlan: `${mobileBasePath}update-plan`,
  mobileHome: `${mobileBasePath}home`,
  createWantAdResponsive: `${mobileBasePath}create-want-listing`,
  changePassword: `${mobileBasePath}update-password`,
  mobileInapp: `${mobileBasePath}inapp`,
  viewAd: `${mobileBasePath}view-listing`,
  strengthenAdResponsive: `${mobileBasePath}strengthen-want-listing`,
  mobileSettings: `${mobileBasePath}settings`,
  mobileBaseRoot: "/",
  mobileRoot: "/mobile",
  messages: "/messages",
  directMessages: "/direct-messages",
  proDashboard: `${mobileBasePath}pro-dashboard`,
  agentClientListing: `${mobileBasePath}agent-client-listing`,
  favoriteClients: "/favorite-clients",
  webFavorites: "/my-favorites",
  viewClientDetailsMob: `${mobileBasePath}view-client`,
  mobileReceiveIntroNotification: `${mobileBasePath}receive-intro-notification`,
  myWantAds: `${mobileBasePath}my-want-listings`,
  mobileEditWantAd: `${mobileBasePath}edit-want-listing`,
  mobileClientNoteListing: `${mobileBasePath}client-notes-list`,
  mobileManageInventory: `${mobileBasePath}manage-inventory`,
  mobileClientInventory: `${mobileBasePath}view-client-inventory`,
  mobileClientWantAd: `${mobileBasePath}view-client-want-listing`,
  mobileReviewOrder: `${mobileBasePath}review-order`,
  mobileCreateInventory: `${mobileBasePath}create-inventory`,
  mobilememberInventoryDetails: `${mobileBasePath}member-view-property`,
  mobileWantAdFavorites: `${mobileBasePath}favorites`,
  clientFavoriteSummary: `${mobileBasePath}client-favorites-summary`,
  mobileAccountSettings: `${mobileBasePath}account-settings`,
  mobilePremiumAgentProfileEdit: `${mobileBasePath}premium-profile-edit`,
  strengthenInventoryReponsive: `${mobileBasePath}strengthen-inventory`,
  mobileEditInventory: `${mobileBasePath}edit-inventory`,
  mobileEditSettingsEmail: `${mobileBasePath}settings-edit-email`,
  mobileEditEmailCheck: `${mobileBasePath}settings-check-email`,
  mobileEmailNotification: `${mobileBasePath}email-notification`,
  mobilePaymentHistory: `${mobileBasePath}payment-history`,
  mobileAddPaymentMethod: `${mobileBasePath}add-payment-method`,
  mobileDeleteAccountCheck: `${mobileBasePath}settings-delete-account`,
  mobilesettingsEditName: `${mobileBasePath}settings-edit-name`,
  mobileInventoryIntroduction: `${mobileBasePath}view-all-introductions`,
  mobileMessages: `${mobileBasePath}messages`,
  mobileDirectMessages: `${mobileBasePath}direct-messages`,
  viewFullGallery: `${mobileBasePath}view-full-gallery`,
  wantAdTutorialResponsive: `${mobileBasePath}want-listing-tutorial`,
  inventoryTutorialResponsive: `${mobileBasePath}inventory-tutorial`,
  mobileMatch: `${mobileBasePath}match`,
  mobilePremiumAgentCreateWantAd: `${mobileBasePath}create-want-listing-mob`,
  buyerListingConfirmation: "/confirmation",
  shareWantAdDetails: `/share/:id`,
  agentInfo: "/agent-info",
  // userTypeSelection: "/user-type",
  // premiumPlanSelection: "/premium-plan-selection",
});

export const urlLinks = Object.freeze({
  gitchaMLSIntegration: "https://gitcha.com/mls",
  contactUs: "https://gitcha.com/contact"
});
